import React, { Component } from 'react';
import { Modal, Button, Row, Input, Upload, message } from 'antd/lib';
import { UploadOutlined } from '@ant-design/icons';

class ModalUploaderFirma extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tipoDoc: undefined,
      fileList: [],
      uploading: false
    };
  }


  handleOk = () => {
    if (!this.state.fileList.length) {
      message.warning('Debe seleccionar un archivo PDF');
      return;
    }
  
    this.setState({ uploading: true });
    
    const file = this.state.fileList[0];
    
    // Convert file to base64
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64File = reader.result.split(',')[1]; // Remove the data URL prefix
      
      // Use the mutation passed via props
      this.props.subirAutorizacionFirmadaPDF({
        variables: {
          idAutorizacion: this.props.idAutorizacion,
          archivo: base64File  // Send the base64 string instead of the File object
        }
      })
      .then(res => {
        // The response key depends on which mutation is used
        const mutationName = Object.keys(res.data)[0];
        if (res.data[mutationName]) {
          message.success('Documento firmado subido correctamente');
          this.props.ocultarModalUploader();
          if (this.props.onSuccess) {
            this.props.onSuccess();
          }
        }
      })
      .catch(err => {
        console.error('Error al subir documento:', err);
        message.error('Error al subir el documento firmado');
      })
      .finally(() => {
        this.setState({ uploading: false });
      });
    };
  };

  render() {
    const uploadProps = {
      accept: 'application/pdf',
      listType: 'picture',

      beforeUpload: file => {
        const isPDF = file.type === 'application/pdf';
        if (!isPDF) {
          message.error(`${file.name} no es un archivo PDF`);
        }
        // TRANSFORMAR ARCHIVO
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          file.base64 = e.target.result;
        };

        this.setState({ fileList: [file], loaded: true });
        return false;
      },
      fileList: this.state.fileList,
      onRemove: file => {
        this.setState({ fileList: [], loaded: false });
      },
    };

    return (
      <Modal
        title="Subir Documento Firmado"
        visible={this.props.mostrarModalUploader}
        onCancel={this.props.ocultarModalUploader}
        onOk={this.handleOk}
        confirmLoading={this.state.uploading}
        okText="Subir"
        cancelText="Cancelar"
      >
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center',
          padding: '20px 0'
        }}>
          <div style={{ marginBottom: '20px', width: '100%' }}>
            <h3 style={{ textAlign: 'center', marginBottom: '16px' }}>Archivo PDF:</h3>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Upload {...uploadProps} required>
                <Button icon={<UploadOutlined />} size="large">
                  Seleccionar PDF
                </Button>
              </Upload>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ModalUploaderFirma; 